/**
 * Created by renjie.huang on 2017/11/7.
 */

var request = require('../common/request');
var Promise = require('promise');
var action = require('../common/action');
var _ = require('_');


var service = {
    fetchCountList : ()=>{
        var promise = new Promise(function(resolve,reject){
            request(action.register.getCountryCodeList,{}).success(function(data){
                resolve(data);
            }).fail(function(data){
                reject(data);
            })
        });

        return promise;
    },

    register : (data)=>{
        var promise = new Promise(function(resolve,reject){
            request(action.register.registerAccount,data).success(function(data){
                resolve(data);
            }).fail(function(data){
                reject(data);
            })
        });
        return promise;
    },

    sendRegisterCode : (data)=>{
        var promise = new Promise(function(resolve,reject){
            request(action.register.sendRegisterPhoneCode,data).success(function(data){
                resolve(data);
            }).fail(function(data){
                reject(data);
            })
        })

        return promise;
    },

    sendActivateEmail : (data)=>{
        var promise = new Promise(function(resolve,reject){
            request(action.register.sendActivateEmail,data).success(function(data){
                resolve(data);
            }).fail(function(data){
                reject(data);
            })
        })

        return promise;
    },

    activeAccount : (data)=>{
        var promise = new Promise(function(resolve,reject){
            request(action.register.activateAccount,data).success(function(data){
                resolve(data);
            }).fail(function(data){
                reject(data);
            })
        })

        return promise;
    },

    getIndustryTypeList : (data)=>{
        var promise = new Promise(function(resolve,reject){
            request(action.register.getIndustryTypeList,data).success(function(data){
                resolve(data);
            }).fail(function(data){
                reject(data);
            })
        })

        return promise;
    },

    isGoHeadEmail : (email)=>{
        var _headEmail = {
            '163.com': 'https://mail.163.com',
            '126.com':'https://mail.126.com',
            '139.com': 'https://mail.10086.com',
            'sohu.com': 'https://mail.sohu.com',
            'sina.com.cn': 'https://mail.sina.com.cn',
            'qq.com': 'https://mail.qq.com',
            '189.com': 'https://webmail30.189.cn',
            '263.net': 'https://www.263.net',
            'gmailcom': 'https://mail.google.com',
            'yeah.net': 'https://email.163.com',
            'foxmail.com': 'https://mail.qq.com',
            'sina.cn': "https://mail.sina.com.cn",
            "sina.com.cn ": "https://mail.sina.com.cn",
            "tom.com": "https://mail.tom.com",
            "outlook.com": "https://login.live.com",
            "hotmail.com": "https://login.live.com",
            "msn.com": "https://login.live.com",
            "aliyun.com": "https://mail.aliyun.com",
            "2980.com": "https://www.2980.com",
            "21cn.com ": "https://mail.21cn.com",
            "188.com": "https://www.188.com",
            "wo.cn": "https://mail.wo.cn",
            "gmail.com": "https://mail.google.com",
            "yahoo.com": "https://login.yahoo.com"
        }


        var _result = false;

        _.each(_headEmail,(value,key)=>{
            if(email.indexOf(key) > -1){
                _result = value;
                return _result;
            }
        })

        return _result;
    },

    getActiveUrl : ()=>{
        return `${document.location.protocol}//${document.location.host}/activeResult?`;
    },

    getRetrieveUrl: ()=>{
        return `${document.location.protocol}//${document.location.host}/retrieveInput?`;
    }

}




module.exports = {
    fetchCountryList : service.fetchCountList,
    sendRegisterCode : service.sendRegisterCode,
    sendActivateEmail : service.sendActivateEmail,
    activeAccount : service.activeAccount,
    getIndustryTypeList : service.getIndustryTypeList,
    register : service.register,
    isGoHeadEmail : service.isGoHeadEmail,
    getActiveUrl : service.getActiveUrl,
    getRetrieveUrl : service.getRetrieveUrl

}


// WEBPACK FOOTER //
// src/service/registerService.js